<template>
  <div class="bb-use-label"
  >
    <span class="bb-use-label__title">
      {{row.title}}
    </span>
    <span class="bb-use-label__text"
          :class="{'bb-use-label__text_transform': label === 'username'}"
    >
      {{value}}
    </span>
  </div>
</template>

<script>
import {get} from 'lodash'
export default {
  name: 'UserLabel',
  props: ['user', 'label', 'row'],
  computed: {
    value () {
      return get(this.user, this.label, '')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../sass/variables";
@import "../../../../sass/mixins";

.bb-use-label {
  width: 100%;
  display: grid;
  grid-template-columns: 123px auto;
  align-items: flex-start;
  padding-bottom: 26px;

  &__title {
    font-style: normal;
    font-weight: 600;
    font-size: 13px;
    line-height: 16px;
    color: $color-denim;
  }

  &__text {
    font-style: normal;
    font-weight: normal;
    font-size: 13px;
    line-height: 151.34%;
    color: $color-black;
    max-width: 164px;
    width: 100%;
    word-break: break-word;

    &_transform {
      text-transform: capitalize;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Settings/UserCard/UserForm/UserLabel.vue